import * as React from "react";
import { useState } from "react";
import {
  Checkbox,
  FormControlLabel,
  FormLabel,
  OutlinedInput,
  IconButton,
  Grid,
  Typography,
  TextField,
  Box,
  MenuItem,
  Select,
} from "@mui/material";
import { styled } from "@mui/system";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { useLocation, useParams } from "react-router-dom";
import {
  getSiteById,
  updateSiteById,
} from "../../services/siteServices/subSiteService";
import {
  getAllPrinciple,
  getPrincipleById,
} from "../../services/siteServices/principleServices";
import {
  getAllPackages,
  getAllPackagesByPrinciple,
} from "../../services/siteServices/packageServices";
import { getAllPartners } from "../../services/PartnerService/PartnerService";

const FormGrid = styled(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px", // Added gap for spacing between label and input
}));

export default function ProjectDesc() {
  const { id } = useParams();
  const [editMode, setEditMode] = useState(false);
  const [projects, setProjects] = useState([]);
  const [packages, setPackages] = useState([]);
  const [project, setProject] = useState("");
  const [packId, setPackId] = useState("");
  const [partners, setPartners] = useState({
    partner: [],
  });
  const [initialForm, setInitialForm] = useState(null);
  const [formData, setFormData] = useState({
    ProjectID: "",
    projectName: "",
    status: "",
    desc: "",
    partnerName: "",
    // PackageID: "",
    // package_name: "",
    // package_rate: "",
  });

  const getSite = async (url) => {
    const res = await getSiteById(url);
    setPackId(res.ProjectDetails?.package_name);
    fetchPackagesByProjectName(res.ProjectDetails?.ProjectName);

    let obj = {
      ProjectID: res.ProjectDetails?.ProjectID,
      projectName: res.ProjectDetails?.ProjectName,
      status: res.ProjectDetails?.project_status,
      desc: res.ProjectDetails?.Description || "",
      partnerName: res.ProjectDetails?.partnerName || "",
    };
    setInitialForm(obj);
    setFormData(obj);
  };

  async function fetchPartners() {
    try {
      const response = await getAllPartners();
      setPartners(response);
    } catch (error) {
      console.log("fetch Partners", error);
    }
  }

  const fetchProjects = async () => {
    try {
      const projectResponse = await getAllPrinciple(); // Assuming `getCities` API returns a list of cities
      setProjects(projectResponse);
    } catch (error) {
      console.log("fetchProjects", error);
    }
  };

  // const fetchPackages = async () => {
  //   try {
  //     const packagesResponse = await getAllPackages(); // Assuming `getCities` API returns a list of cities
  //     setPackages(packagesResponse);
  //   } catch (error) {
  //     console.log("error in fetchPackages", error);
  //   }
  // };
  const fetchPackagesByProjectName = async (name) => {
    try {
      const packagesResponse = await getAllPackagesByPrinciple(name); // Assuming `getCities` API returns a list of cities
      setPackages(packagesResponse);
    } catch (error) {
      console.log("error in fetchPackages", error);
    }
  };
  React.useEffect(() => {
    fetchPartners();
    fetchProjects();
    getSite(id);
  }, []);

  const handleEditToggle = () => setEditMode(!editMode);

  const handleCancelToggle = () => {
    getSite(id);
    setEditMode(!editMode);
  };

  const handleProjectChange = async (event) => {
    const selectedProject = event.target.value;
    console.log("selectedProject", selectedProject);

    setFormData((prev) => ({
      ...prev,
      projectName: selectedProject,
    }));

    try {
      const projectDetails = await getPrincipleById(selectedProject);
      setProject(projectDetails.ProjectID);
      console.log("projectDetails", projectDetails);

      if (projectDetails) {
        // Update state and zone based on the city details
        setFormData((prev) => ({
          ...prev,
          ProjectID: projectDetails.ProjectID || "",
          desc: projectDetails.ProjectDescription || "",
        }));
      }
    } catch (error) {
      console.log("error in handleProjectChange", error);
    }
  };

  const handlePackageChange = (e) => {
    const { name, value } = e.target;
    const Package = packages.find((pack) => pack.PackageName == value);
    console.log("Package", Package);
    setFormData((prev) => ({
      ...prev,
      PackageID: Package.PackageID,
      package_name: Package.PackageName,
      package_rate: Package.RatePerSQFT,
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    const changedFields = {};
    Object.keys(formData).forEach((key) => {
      if (formData[key] !== initialForm[key]) {
        changedFields[key] = formData[key];
      }
    });
    console.log("Updated data: ", changedFields);

    // const obj = {
    //   ProjectID: project,
    //   PackageID: formData.PackageID,
    //   principleName: formData.projectName,
    //   package_name: formData.package_name,
    //   package_rate: formData.package_rate,
    // };

    try {
      if (Object.keys(changedFields).length > 0) {
        const update = await updateSiteById(id, changedFields);
        getSite(id);
      }
      setEditMode(false);
    } catch (error) {
      console.log("error in handleSubmit", error);
    }

    setEditMode(false);
  };

  return (
    <Box>
      <Grid container spacing={2}>
        {/* Edit / Save / Cancel Buttons */}
        <Grid item xs={12} display="flex" justifyContent="flex-end">
          {editMode ? (
            <>
              <IconButton onClick={handleSubmit} sx={{ color: "green" }}>
                <SaveIcon />
              </IconButton>
              <IconButton onClick={handleCancelToggle} sx={{ color: "red" }}>
                <CancelIcon />
              </IconButton>
            </>
          ) : (
            <IconButton onClick={handleEditToggle}>
              <EditIcon />
            </IconButton>
          )}
        </Grid>

        {/* Partner  Name */}
        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="city">Partner Name</FormLabel>
          {editMode ? (
            <Select
              id="projectName"
              name="projectName"
              value={formData.partnerName}
              onChange={handleProjectChange}
              size="small"
              variant="outlined"
              required
              disabled
            >
              <MenuItem
                key={0}
                // name={principle.ProjectID}
                value={""}
              >
                {""}
              </MenuItem>
              {partners.partner.map((item) => (
                <MenuItem
                  key={item.id}
                  // name={principle.ProjectID}
                  value={item.name}
                >
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          ) : (
            <Typography>{formData.partnerName}</Typography>
          )}
        </FormGrid>

        {/* Project Name */}
        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="city">Principle Name</FormLabel>
          {editMode ? (
            <Select
              id="projectName"
              name="projectName"
              value={formData.projectName}
              onChange={handleProjectChange}
              size="small"
              variant="outlined"
              required
              disabled
            >
              <MenuItem
                key={0}
                // name={principle.ProjectID}
                value={""}
              >
                {""}
              </MenuItem>
              {projects.map((principle) => (
                <MenuItem
                  key={principle.ProjectID}
                  // name={principle.ProjectID}
                  value={principle.ProjectName}
                >
                  {principle.ProjectName}
                </MenuItem>
              ))}
            </Select>
          ) : (
            <Typography>{formData.projectName}</Typography>
          )}
        </FormGrid>

        {/* Status */}
        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="status" required>
            Status
          </FormLabel>
          {editMode ? (
            <TextField
              disabled
              id="status"
              name="status"
              value={formData.status}
              onChange={handleChange}
              size="small"
              variant="outlined"
              required
            />
          ) : (
            <Typography>{formData.status}</Typography>
          )}
        </FormGrid>

        {/* desc */}
        <FormGrid xs={12} p={2}>
          <FormLabel htmlFor="desc" required>
            Description
          </FormLabel>
          {editMode ? (
            <TextField
              id="desc"
              name="desc"
              value={formData.desc}
              onChange={handleChange}
              multiline
              rows={4}
              variant="outlined"
              size="small"
              required
              disabled
            />
          ) : (
            <Typography>{formData.desc}</Typography>
          )}
        </FormGrid>
        {/* Package ID */}
        {/* <FormGrid xs={12} p={2}>
          <FormLabel htmlFor="packageId">Package Name</FormLabel>
          {editMode ? (
            <Select
              id="PackageID"
              name="PackageID"
              value={formData.package_name}
              onChange={handlePackageChange}
              size="small"
              variant="outlined"
              required
            >
              {packages.map((pack) => (
                <MenuItem key={pack.PackageID} value={pack.PackageName}>
                  {pack.PackageName}
                </MenuItem>
              ))}
            </Select>
          ) : (
            <Typography>{formData.package_name}</Typography>
          )}
        </FormGrid> */}

        {/* Add spacing between sections */}
        <Box mt={2} />
      </Grid>
    </Box>
  );
}
